
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  onMounted,
  ref,
  computed
} from 'vue'
import { required } from '@/utils/rules'
import { editSetting, addSetting } from './api'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'

export default defineComponent({
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      required: true,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
    isType: {
      type: String,
      default: () => {},
    },
  },
  // emits: ['update:modelValue'],
  setup(props, { emit }) {
    const data = reactive({
      visible: false,
      titlename: 'AEB告警分类',
      formRef: undefined,
      formData: ref<any>({}),
      id: 0,
      rules: {
        alarmTypeCode: [required],
        alarmTypeName: [required],
        alarmClassify: [required],
        alarmLevel: [required],
      },
      isdisable: false,
    })

    watchEffect(() => {
      data.visible = props.modelValue
    })

    const titlename = computed(() => {
      return props.isType === 'edit' ? '编辑AEB告警分类' : '新增AEB告警分类'
    })

    /**
     * @description: 关闭dialog
     * @param {*} void
     * @return {*}
     */
    const onCancel = (): void => {
      data.visible = false
      emit('update:modelValue', false)
      emit('getListFn')
    }
    
    const init = () => {
      if (props.isType === 'edit') {
        data.formData = {
          alarmTypeCode: props.row.alarmTypeCode || '',
          alarmTypeName: props.row.alarmTypeName || '',
          alarmClassify: props.row.alarmClassify || null,
          alarmLevel: props.row.alarmLevel || null,
          systemClassify: props.row.systemClassify || null
        }
        data.id = props.row.id || 0
        data.isdisable = true
      } else {
        data.formData = {
          alarmTypeCode: '',
          alarmTypeName: '',
          alarmClassify: null,
          alarmLevel: null,
          systemClassify: null
        }
        data.id = 0
        data.isdisable = false
      }
    }

    // 提交表单
    const handleSubmit = () => {
      data.formRef.validate(async (valid) => {
        if (valid) {
          const submitData: any = {
            alarmTypeCode: data.formData.alarmTypeCode,
            alarmTypeName: data.formData.alarmTypeName,
            alarmClassify: data.formData.alarmClassify,
            alarmLevel: data.formData.alarmLevel,
            systemClassify: data.formData.systemClassify
          }
          
          if (props.isType === 'edit') {
            submitData.id = data.id
            const [err] = await toResult(editSetting(submitData))
            if (err) return false
          } else {
            const [err] = await toResult(addSetting(submitData))
            if (err) return false
          }

          ElMessage.success('操作成功')
          onCancel()
        }
      })
    }

    onMounted(() => {
      init()
    })
    
    return {
      ...toRefs(data),
      titlename,
      handleSubmit,
      onCancel,
      init,
    }
  },
})
